import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Select, SelectItem } from '@repo/design-system/components/ui/select';
import { useAppDispatch, useAppSelector } from '@repo/store/maps/hooks';
import { selectMapData } from '@repo/store/maps/slices/mapData';
import { selectSelectedMapObject3dId, setSelectedMapObject3dId } from '@repo/store/maps/slices/mapObjects3d';
import type { MapData3dObject } from '@repo/types/maps/map-3d-types';
import { useCallback } from 'react';
import { use3dObjectsLookupMap } from '../../game-map/hooks/use3dObjectsLookupMap';
import { useObject3dPlacement } from '../../game-map/hooks/useObject3dPlacement';
export const Object3dTools = () => {
  const $ = _c(21);
  const dispatch = useAppDispatch();
  const mapData = useAppSelector(selectMapData);
  const selected3dObjectId = useAppSelector(selectSelectedMapObject3dId);
  const {
    isAdding3dObject,
    startAdding3dObject,
    cancelAdding3dObject
  } = useObject3dPlacement();
  let t0;
  if ($[0] !== mapData?.objects3d?.features) {
    t0 = mapData?.objects3d?.features || [];
    $[0] = mapData?.objects3d?.features;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const models = t0;
  const modelsById = use3dObjectsLookupMap(mapData);
  let t1;
  if ($[2] !== modelsById || $[3] !== selected3dObjectId || $[4] !== startAdding3dObject) {
    t1 = () => {
      let defaultProps = {
        title: "New 3D Object",
        scale: {
          x: 1,
          y: 1,
          z: 1
        },
        quaternion: {
          x: 0,
          y: 0,
          z: 0,
          w: 1
        },
        minZoom: 1,
        maxZoom: 20
      };
      let defaultPosition;
      if (selected3dObjectId) {
        const selectedModel = modelsById.get(selected3dObjectId);
        if (selectedModel) {
          defaultProps = {
            title: "New 3D Object",
            type: selectedModel?.properties?.type ?? "model",
            scale: selectedModel?.properties?.scale ?? {
              x: 1,
              y: 1,
              z: 1
            },
            quaternion: selectedModel?.properties?.quaternion ?? {
              x: 0,
              y: 0,
              z: 0,
              w: 1
            },
            minZoom: selectedModel?.properties?.minZoom ?? 1,
            maxZoom: selectedModel?.properties?.maxZoom ?? 20,
            color: selectedModel.properties.color,
            intensity: selectedModel.properties.intensity
          };
          const [lng, lat, t2] = selectedModel.geometry.coordinates;
          const elevation = t2 === undefined ? 0 : t2;
          defaultPosition = [lng, lat, elevation];
        }
      }
      startAdding3dObject(defaultProps, defaultPosition);
    };
    $[2] = modelsById;
    $[3] = selected3dObjectId;
    $[4] = startAdding3dObject;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleStartAdding3dObject = t1;
  let t2;
  if ($[6] !== dispatch) {
    t2 = modelId => {
      dispatch(setSelectedMapObject3dId(modelId));
    };
    $[6] = dispatch;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleModelSelect = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>Add New 3D Object</div>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== cancelAdding3dObject || $[10] !== handleStartAdding3dObject || $[11] !== isAdding3dObject) {
    t4 = <FlexColumn gap="8">{t3}<FlexRow gap="8">{!isAdding3dObject ? <Button onClick={handleStartAdding3dObject} variant="filled" color="brand" size="sm">Add 3D Object</Button> : <Button onClick={cancelAdding3dObject} variant="filled" color="error" size="sm">Cancel</Button>}</FlexRow></FlexColumn>;
    $[9] = cancelAdding3dObject;
    $[10] = handleStartAdding3dObject;
    $[11] = isAdding3dObject;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleModelSelect || $[14] !== models || $[15] !== modelsById || $[16] !== selected3dObjectId) {
    t5 = models.length > 0 && <FlexColumn gap="8"><div>Edit Existing Model</div><Select value={selected3dObjectId ?? undefined} onValueChange={handleModelSelect} placeholder="Select a 3D object" size="sm" fullWidth={true} trigger={<Button color="primary" size="sm">{selected3dObjectId ? modelsById.get(selected3dObjectId)?.properties.title || "Unnamed Model" : "Select a 3D object"}</Button>}>{models.map(_temp)}</Select></FlexColumn>;
    $[13] = handleModelSelect;
    $[14] = models;
    $[15] = modelsById;
    $[16] = selected3dObjectId;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t4 || $[19] !== t5) {
    t6 = <FlexColumn gap="12">{t4}{t5}</FlexColumn>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
function _temp(model) {
  return <SelectItem key={model.properties.externalId} item={{
    label: model.properties.title || "Unnamed Model",
    value: model.properties.externalId
  }}>{model.properties.title || "Unnamed Model"}</SelectItem>;
}